import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import WS from "utils/ws";
import { fetchRobots, setSelectedRobot } from "store/reducers/RobotsSlice";
import {
    getTabs,
    resetTabsStateForRobot,
    getTickers,
} from "store/reducers/TabsSlice";
import { resetQuotesState, setActivePageId } from "store/reducers/quotes";
import { resetFilterState } from "store/reducers/FilterSlice";
import {
    resetQuotesPageState,
    setActivePage,
} from "store/reducers/QuotesPageReducer";
import { RootState } from "store/store";

export const useAppInitialization = () => {
    const dispatch = useDispatch();
    const { loggedIn } = useSelector((state: RootState) => state.auth);
    const { robots, selectedRobotId } = useSelector(
        (state: RootState) => state.robots,
    );

    useEffect(() => {
        const savedId = localStorage.getItem("selectedRobotId");
        if (savedId) {
            dispatch(setSelectedRobot(savedId));
        }
    }, [dispatch]);

    useEffect(() => {
        if (!loggedIn) return;
        if (robots.length === 0) {
            dispatch(fetchRobots());
        }
    }, [dispatch, loggedIn, robots.length]);
    useEffect(() => {
        if (!loggedIn) return;
        if (!selectedRobotId) return;
        
        WS.disconnectAll();
        dispatch(resetQuotesState());
        dispatch(resetTabsStateForRobot());
        dispatch(resetQuotesPageState());
        dispatch(resetFilterState());
        dispatch(setActivePage(null));
        dispatch(setActivePageId(""));

        dispatch(getTabs());
        dispatch(getTickers());
        
    }, [selectedRobotId, dispatch,loggedIn]);
    useEffect(() => {
        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.has("ticker")) {
            currentUrl.searchParams.delete("ticker");
            window.history.replaceState({}, "", currentUrl.toString());
        }
    }, [selectedRobotId]);
        useEffect(() => {
            if (!loggedIn) return;
            if (!selectedRobotId) return;
    
            dispatch(getTabs());

        }, [selectedRobotId, dispatch, loggedIn]);
    useEffect(() => {
        if (!loggedIn || !selectedRobotId || robots.length === 0) return;

        const exists = robots.some((r) => r.robot_id === selectedRobotId);
        if (!exists) {
            if (robots.length > 0) {
                const firstId = robots[0].robot_id;
                dispatch(setSelectedRobot(firstId));
            } else {
                dispatch(setSelectedRobot(null));
            }
        }
    }, [dispatch, loggedIn, selectedRobotId, robots]);
};
